import { Provider } from '@angular/core';

export const aimoHandlers: Provider[] = [];
